import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import { range } from 'libs';
import { useEffect, useState } from 'react';
import { RefuelHistory, RefuelHistoryRequestParam, Vehicle } from 'types';

type Props = {
  open: boolean;
  vehicle: Vehicle;
  history: RefuelHistory;
  onClickUpdateHistory: (history: RefuelHistoryRequestParam) => void;
  onClose: () => void;
};

const RefuelHistoryModal: React.FC<Props> = ({
  open,
  vehicle,
  history,
  onClickUpdateHistory,
  onClose,
}) => {
  const [historyYear, setHistoryYear] = useState('');
  const [historyMonth, setHistoryMonth] = useState('');
  const [historyDay, setHistoryDay] = useState('');
  const [historyMileage, setHistoryMileage] = useState(0);
  const [historyTotalMileage, setHistoryTotalMileage] = useState(0);
  const [historyFuelPrice, setHistoryFuelPrice] = useState(0);
  const [historyRefuelAmount, setHistoryRefuelAmount] = useState(0);

  useEffect(() => {
    const date = new Date(history.refuel_at * 1000);
    setHistoryYear(date.getFullYear().toString());
    setHistoryMonth((date.getMonth() + 1).toString());
    setHistoryDay(date.getDate().toString());

    setHistoryMileage(history.mileage);
    setHistoryTotalMileage(vehicle.total_mileage);
    setHistoryRefuelAmount(history.refuel_amount);
  }, [vehicle, history]);

  const onSubmit = () => {
    if (historyDay === '' || historyMonth === '' || historyDay === '') return;

    const refuelAt =
      new Date(
        parseInt(historyYear, 10),
        parseInt(historyMonth, 10) - 1,
        parseInt(historyDay, 10),
        9,
      ).getTime() / 1000;

    const newHistory: RefuelHistoryRequestParam = {
      id: history.id,
      refuel_at: refuelAt,
      mileage: historyMileage,
      total_mileage: historyTotalMileage,
      refuel_amount: historyRefuelAmount,
      fuel_price: historyFuelPrice,
    };

    onClickUpdateHistory(newHistory);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
      }}
    >
      <DialogContent>
        <Stack spacing={3} maxWidth={400}>
          <Select
            label="年"
            name="year"
            autoWidth
            onChange={(event) => {
              setHistoryYear(event.target.value);
            }}
            value={historyYear}
          >
            {[2024, 2025, 2026].map((y, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <MenuItem key={index} value={y}>
                {y}
              </MenuItem>
            ))}
          </Select>
          <Select
            label="月"
            name="month"
            autoWidth
            onChange={(event) => {
              setHistoryMonth(event.target.value);
            }}
            value={historyMonth}
          >
            {range(1, 13).map((m, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <MenuItem key={index} value={m}>
                {m}
              </MenuItem>
            ))}
          </Select>
          <Select
            label="日"
            name="day"
            autoWidth
            onChange={(event) => {
              setHistoryDay(event.target.value);
            }}
            value={historyDay}
          >
            {range(1, 32).map((d, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <MenuItem key={index} value={d}>
                {d}
              </MenuItem>
            ))}
          </Select>
          <TextField
            margin="normal"
            required
            label="走行距離"
            type="number"
            name="mileage"
            onChange={(event) =>
              setHistoryMileage(parseInt(event.target.value, 10))
            }
            value={historyMileage}
          />
          <TextField
            margin="normal"
            required
            label="総走行距離"
            type="number"
            name="total_mileage"
            onChange={(event) =>
              setHistoryTotalMileage(parseInt(event.target.value, 10))
            }
            value={historyTotalMileage}
          />
          <TextField
            margin="normal"
            required
            label="給油量"
            type="number"
            name="refuel_amount"
            onChange={(event) =>
              setHistoryRefuelAmount(parseInt(event.target.value, 10))
            }
            value={historyRefuelAmount}
          />
          <TextField
            margin="normal"
            required
            label="燃料単価"
            type="number"
            name="fuel_price"
            onChange={(event) =>
              setHistoryFuelPrice(parseInt(event.target.value, 10))
            }
            value={historyFuelPrice}
          />
        </Stack>
        <DialogActions>
          <Button
            type="submit"
            variant="contained"
            sx={{ maxWidth: '64px' }}
            onClick={onSubmit}
          >
            更新
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default RefuelHistoryModal;
